import React from 'react';
import StatisticsProvider from '../../StatisticsProvider';
import useStatistics from '../../../../hooks/data/useStatistics';
import HelperMethods from '../../../../services/exports/HelperMethods';
import Metric from '../../../../components/stats/Metric';
import MetricsContainer from '../../../../components/stats/MetricsContainer';

function MobileApp({ dateRangeFilter, company }) {
  return (
    <StatisticsProvider
      mainMetrics={['sales', 'mobile_app_sales', 'mobile_app_average_order_value', 'mobile_app_orders_count']}
      mobileAppMetrics={['mobile_app_downloads']}
      dateRangeFilter={dateRangeFilter}
      company={company}
    >
      <Metrics />
    </StatisticsProvider>
  );
}

function Metrics() {
  const { stats, loadingMain, getMetricLabel, loadingMobileApp } = useStatistics();
  const getRevenuePercentageItems = () => {
    const value = HelperMethods.percentagePart(stats.mobile_app_sales?.value.amount, stats.sales?.value.amount) || 0;
    const previous =
      HelperMethods.percentagePart(stats.mobile_app_sales?.previous.amount, stats.sales?.previous.amount) || 0;
    const change = value - previous;

    return {
      value,
      previous,
      change,
    };
  };

  const getMobileAppDownloadsItems = () => {
    if (!stats.mobile_app_downloads) {
      return;
    }

    const change = HelperMethods.percentagePart(
      stats.mobile_app_downloads.value - stats.mobile_app_downloads.previous,
      stats.mobile_app_downloads.previous,
    );

    return {
      ...stats.mobile_app_downloads,
      change,
    };
  };

  const metrics = stats
    ? [
        <Metric
          key="mobile_app_downloads"
          name={getMetricLabel('mobile_app_downloads')}
          loading={loadingMobileApp}
          mobileAppMetrics={['mobile_app_downloads']}
          items={getMobileAppDownloadsItems()}
        />,
        <Metric
          key="mobile_app_gmv"
          name={getMetricLabel('mobile_app_gmv')}
          loading={loadingMain}
          mainMetrics={['mobile_app_sales']}
          items={stats.mobile_app_sales}
        />,
        <Metric
          key="mobile_app_gmv_percentage"
          name={getMetricLabel('mobile_app_gmv_percentage')}
          loading={loadingMain}
          mainMetrics={['mobile_app_sales', 'sales']}
          formatter={HelperMethods.formatPercentage}
          items={getRevenuePercentageItems()}
        />,
        <Metric
          key="mobile_app_orders_count"
          name={getMetricLabel('mobile_app_orders_count')}
          loading={loadingMain}
          mainMetrics={['mobile_app_orders_count']}
          items={stats.mobile_app_orders_count}
        />,
        <Metric
          key="mobile_app_average_order_value"
          name={getMetricLabel('mobile_app_average_order_value')}
          items={stats.mobile_app_average_order_value}
          loading={loadingMain}
          mainMetrics={['mobile_app_average_order_value']}
        />,
      ]
    : [];

  return <MetricsContainer metrics={metrics} />;
}

export default MobileApp;
